import React from 'react'
import {UserItem} from 'common/Items'
import {BackpackIcon} from 'common/Icons'
import {BackpackViewModal} from 'common/Backpack'

import {useQuery, useModal} from 'hooks'
import {queryAdventureParticipations, queryUserParticipations} from 'graph'

function Participation({participation}: any)
{
  const {receiver, backpack} = participation
  // Any adventure-viewer may inspect every participant's backpack (even an empty
  // one — the modal then shows "Nothing packed yet"). To follow a participant,
  // click their avatar and subscribe there (no Subscribe button in this card).
  const openBackpack = useModal(BackpackViewModal, {backpack, user: receiver})

  return (
    <UserItem
      user={receiver}
      renderButton={() => (
        <div className="col-auto d-flex align-items-center">
          <button
            type="button"
            className="btn btn-link text-muted p-0"
            title={`View ${receiver.fullname}'s backpack`}
            onClick={() => openBackpack()}
          >
            <BackpackIcon />
          </button>
        </div>
      )}
    />
  )
}

function Participations({participations}: any)
{
  return (
    <div className="card">
      <div className="card-header">
        <h4 className="card-header-title">
          Participants
        </h4>
      </div>
      <div className="card-body">
        <div className="list-group list-group-flush my-n3">
          {participations.map((participation: any) => (
            <Participation
              key={participation.id}
              participation={participation}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export function AdventureParticipations({adventure}: any)
{
  const {data, loading} = useQuery(queryAdventureParticipations, {
    variables: {
      id: adventure.id
    }
  })

  return (
    <Participations
      loading={loading}
      participations={data?.adventure.participations.edges || []}
    />
  )
}

export function UserParticipations({user}: any)
{
  const {data, loading} = useQuery(queryUserParticipations, {
    variables: {
      id: user.id
    }
  })

  return (
    <Participations
      loading={loading}
      participations={data?.user.participations.edges || []}
    />
  )
}
